export const MISSING_PROVIDER_ERROR = 'NavigationCollapseProvider not found';
